import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Pager = ({ data, page, setPage, testid = "pager" }) => {
  if (!data || data.total <= data.page_size) return null;
  const from = (page - 1) * data.page_size + 1;
  const to = Math.min(page * data.page_size, data.total);
  return (
    <div className="flex items-center justify-between gap-3 px-4 py-3 text-sm text-[#0A1128]" data-testid={testid}>
      <span data-testid={`${testid}-info`}>{from}–{to} di <strong>{data.total}</strong></span>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)} className="rounded-full h-8" data-testid={`${testid}-prev`}><ChevronLeft className="h-4 w-4" />Precedente</Button>
        <span className="px-1 font-semibold" data-testid={`${testid}-page`}>Pagina {page} di {data.pages}</span>
        <Button size="sm" variant="outline" disabled={page >= data.pages} onClick={() => setPage(page + 1)} className="rounded-full h-8" data-testid={`${testid}-next`}>Successiva<ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
